<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">受注製品検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" @submit.prevent>
				<p class="caption">※一括取得できる件数は最大２０件までです</p>
				<v-row v-if="searchedOrderedProducts" align="center" justify="space-around" no-gutters>
					<v-text-field
						type="text"
						v-model="searchWord"
						class="mt-2 mx-1"
						label="製造番号"
						outlined
						dense
					/>
				</v-row>
				<p class="secondary--text text-center" v-if="noResultFlag">該当するデータはありません</p>

				<v-row no-gutters align="center" justify="space-around">
					<v-btn
						class="mt-2 mx-1"
						:disabled="!searchWord"
						@click="searchOrderedProducts(searchWord)"
						><v-icon>mdi-magnify</v-icon>検索</v-btn
					>
				</v-row>
			</v-form>
			<v-row no-gutters justify="space-around"
				><v-btn
					class="ma-2 pa-2 pre-wrap height100p text-align-left"
					v-for="orderedProduct in searchedOrderedProducts"
					:key="orderedProduct.id"
					v-text="orderedProductInfo(orderedProduct)"
					@click="setOrderedProduct(orderedProduct)"
				></v-btn
			></v-row>
			<v-card-actions>
				<v-row no-gutters class="pb-2"> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"

import rules from "../../../helper/rules"

export default {
	data() {
		return {
			common: common,
			dialog: false,
			noResultFlag: false,
			searchWord: null,
			searchedOrderedProducts: [],
		}
	},
	methods: {
		orderedProductInfo(op) {
			return (
				"製造番号：" +
				op.product_number +
				"\n製品名　：" +
				op.product.name +
				"\n数量　　：" +
				op.quantity
			)
		},
		openDialog() {
			this.dialog = true
		},
		searchOrderedProducts() {
			let th = this
			async function main() {
				let response = await th.common.searchOrderedProducts(th.searchWord)
				th.searchedOrderedProducts = response.data.ordered_products
				if (th.searchedOrderedProducts.length == 0) {
					th.noResultFlag = true
				} else {
					th.noResultFlag = false
				}
			}
			main()
		},
		setOrderedProduct(orderedProduct) {
			this.selectedOrderedProduct = orderedProduct
			this.$emit("setOrderedProduct", this.selectedOrderedProduct)
			this.searchedOrderedProducts = []
			this.searchWord = ""
			this.dialog = false
		},
	},
	watch: {
		statusIdsHash() {
			if (this.statusIdsHash != null) {
				let keys = Object.keys(this.statusIdsHash)
				keys.forEach((key) => {
					this.statusAndJapanese.push({
						text: this.statusIdsHash[key],
						value: key,
					})
				})
			}
		},
	},
	computed: {},
}
</script>
